export default __webpack_public_path__ + "static/media/home-qualification21.4a97dcfe.png";